/*eslint-disable */
import {bus} from '../../main';
import headerBeforeLogin from '../headerBeforeLogin/index';

export default {
  name: 'app_header',
  components: {
    'header-before-login': headerBeforeLogin,
  },
  props: [],
  data () {
    return {
      isLoggin: ''
    }
  },
  computed:{ 
  },
  
  mounted () {
  },
  methods: {
    
  },
  updated(){
    
  },
  created(){
  },
  watch: {
  }
}
